import { StringParam, useQueryParam, withDefault } from 'use-query-params';

import { isSafeRedirectPath } from '@app/router/utils/redirectPath.utils';

import { AUTH_QUERY_PARAM_REDIRECT } from '../auth.constants';

/**
 * Terugkeer-na-inloggen: carries the `redirect` param between the auth pages (sign-in,
 * sign-up, forgot-password) so bouncing between them - "already have an account? sign in",
 * "forgot password?" - doesn't silently drop the destination the route guard originally set.
 * `redirectQueryParams` is shaped for spreading straight into a TypedLink's `queryParams` prop;
 * it's `{}` (not `{redirect: null}`) when there's nothing valid to carry, since
 * `new URLSearchParams({redirect: null})` would otherwise render a literal "null" in the URL.
 *
 * Read-only, same as everywhere else this param is read - never call this hook's setter.
 */
export function useRedirectQueryParam() {
  const [redirectTarget] = useQueryParam(AUTH_QUERY_PARAM_REDIRECT, withDefault(StringParam, null));
  const isValid = isSafeRedirectPath(redirectTarget);

  const redirectQueryParams: Record<string, string> = isValid ? { [AUTH_QUERY_PARAM_REDIRECT]: redirectTarget } : {};

  return {
    redirectTarget: isValid ? redirectTarget : null,
    redirectQueryParams,
  };
}
